:host {
  .connected-title {
    color: #979ba4;
    color: var(--font-tertiary);
    font-size: 15px;
    margin-bottom: 20px;
  }

  .connected-actions {
    display: flex;
    justify-content: center;
    margin-top: 20px;

    button {
      cursor: pointer;
      width: 100%;
      border: 1px solid #0098ff;
      background: white;
      background: var(--bg-primary);
      color: #0098ff;
      padding: 10px 20px;
      font-size: 14px;
      letter-spacing: 0;
      line-height: 18px;
      text-align: center;
      margin: 0 5px;
      border-radius: 6px;
      box-sizing: border-box;

      &:focus {
        outline: none;
      }

      &:hover {
        transition: all 0.3s;
        background: #0098ff;
        color: white;
      }

      &:disabled {
        background: rgba(0, 0, 0, 0.12);
        background: var(--bg-disabled-button);
        border: none;
        color: rgba(0, 0, 0, 0.26);
        color: var(--font-disabled);
        cursor: not-allowed;
      }
    }

    &--vertical {
      flex-direction: column;

      button {
        margin-bottom: 10px;
        width: auto;
      }
    }
  }

  /* -------------------------------------------------------------------------- */
  /*                                 RESPONSIVE                                 */
  /* -------------------------------------------------------------------------- */

  // Medium devices (tablets, 768px and up)
  @media (max-width: 768px) {
    .connected-actions {
      flex-direction: column;

      button {
        margin-bottom: 10px;
      }

      button:last-child {
        margin-bottom: 0;
      }
    }
  }
}
